<template>
  <div>
    <div v-if="step == 'FORMS'">
      <Forms
        :resident_id="resident_id"
        :rest_home_id="rest_home_id"
        :loadingCreate="loadingCreate"
        v-on:clickRowTable="clickRowTable"
      />
    </div>
    <div v-if="step == 'FORM'">
      <Form
        :rest_home_id="rest_home_id"
        v-on:success="$emit('success')"
        v-on:clickBack="handleClickBack"
        :form="form"
      />
    </div>
  </div>
</template>

<script>
import Forms from "./Forms";

import Form from "./Form";

import { userData } from "../../../lib/functions";

import api from "../../../services/api";

export default {
  name: "Answer",
  components: {
    Forms,
    Form,
  },
  created() {
    this.retrieve();
  },
  props: {
    resident_id: [Number, String],
    loadingCreate: [Boolean],
  },
  data() {
    return {
      step: "FORMS",
      rest_home_id: "",
      form: "",
      loading: false,
    };
  },
  methods: {
    handleClickBack() {
      this.step = "FORMS";
      this.$emit("form", { open: false, form: {} });
    },
    retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;
    },
    clickRowTable(form) {
      this.verifyFormOpen(form);
    },
    async verifyFormOpen(item) {
      try {
        this.loading = true;

        this.form = item;

        let { resident_id } = this;

        let params = { resident_id, form_id: item.id };

        let response = await api.get("/rest-home/resident/semiology-open", {
          params,
        });

        let { error, exist, form } = response.data;

        if (!error) {
          if (exist) {
            this.$emit("form", { open: true, form });
          } else {
            this.step = "FORM";
            this.$emit("form", { open: false, form: item });
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
